import React, { useState, useEffect} from "react";
import Sidebar from "../components/sidebar";
import { Toolbar } from "primereact/toolbar";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
} from "@mui/material";
import TelegramWidget from "../components/widget/telegramWidget";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Switch, FormControlLabel, Box
} from "@mui/material";
import {BASE_URL} from '../utils/config'

const StockSRLevel = () => {
  const [records, setRecords] = useState([
    {
      id: 1,
      symbol: "NSE:NIFTY",
      support: "",
      resistence: "",
      changedBy: "",
      changed_at: null,
      sendTelegram: false 
    },
    {
      id: 2,
      symbol: "NSE:NIFTY_MID_SELECT",
      support: "",
      resistence: "",
      changedBy: "",
      changed_at: null,
      sendTelegram: false 
    },
  ]);

const [confirmOpen, setConfirmOpen] = useState(false);
const [successOpen, setSuccessOpen] = useState(false);
const [errorOpen, setErrorOpen] = useState(false);
const [errorMessage, setErrorMessage] = useState("");
const [pendingRow, setPendingRow] = useState(null);
const [telegramToggle, setTelegramToggle] = useState(true);
const [isSending, setIsSending] = useState(false);


  const handleChange = (id, field, value) => {
    setRecords((prev) =>
      prev.map((row) =>
        row.id === id ? { ...row, [field]: value } : row
      )
    );
  };

  const centerToolbarTemplate = () => (
    <h2 style={{ marginTop: "0px" }}>ADD NKB LEVEL</h2>
  );


  const confirmUpdate = async () => {
  
    if (!pendingRow) return;
    setIsSending(true); // start loading

  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const userDetails = JSON.parse(localStorage.getItem("userdetails"));

  if (!loginData || !loginData.token) {
    setErrorMessage("You are not logged in. Please login again.");
    setErrorOpen(true);
    setIsSending(false);
    return;
  }

  if (!userDetails || !userDetails.first_name) {
    setErrorMessage("User details not found. Please login again.");
    setErrorOpen(true);
    
    setIsSending(false); // start loading
    return;
  }

  
const resolvedSymbol =
  pendingRow.symbol === "NSE:NIFTY" || pendingRow.symbol === "NIFTY"
    ? "NIFTY"
    : "MIDCPNIFTY";

const toNullableNumber = (v) => {
  if (v === "" || v === null || v === undefined) return null;
  if (Number.isNaN(Number(v))) return null;
  return Number(v);
};

const payload = {
  symbol: resolvedSymbol,
  support: toNullableNumber(pendingRow.support),
  resistence: toNullableNumber(pendingRow.resistence),
  changedBy: userDetails.first_name,
  sendTelegram: telegramToggle
};

console.log("FINAL PAYLOAD (frontend):", payload);


  try {
    const response = await fetch(
      `${BASE_URL}/update_nkb_levels`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${loginData.token}`,
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await response.json();

    if (!response.ok) {
      setErrorMessage(data.message || "Update failed");
      setErrorOpen(true);
      return;
    }

    const now = new Date();

    setRecords(prev =>
      prev.map(row =>
        row.id === pendingRow.id
          ? {
              ...row,
              changedBy: userDetails.first_name,
              changed_at: now.toISOString()
            }
          : row
      )
    );
    await fetchLevels();

    setSuccessOpen(true);

    setTimeout(() => {
      setIsSending(false);
      setConfirmOpen(false); // close popup after 2 sec
      setSuccessOpen(false);
      setPendingRow(null);
    }, 2000);

  } catch (err) {
    setConfirmOpen(false);
    setErrorMessage("Server error");
    setErrorOpen(true);
  }
};

const priceBoxStyle = {
  border: "1px dashed #c4c4c4",
  borderRadius: "10px",
  padding: "10px 16px",
  minWidth: "120px",
  textAlign: "center",
};

const priceLabelStyle = {
  fontSize: "12px",
  color: "#666",
  marginBottom: "4px",
};

const priceValueStyle = {
  fontSize: "18px",
  fontWeight: "bold",
};

const hasSRValue =
  pendingRow &&
  (
    (pendingRow.support !== "" && pendingRow.support !== null) ||
    (pendingRow.resistence !== "" && pendingRow.resistence !== null)
  );

 const fetchLevels = async () => {
  const loginData = JSON.parse(localStorage.getItem("loginData"));
  if (!loginData?.token) return;

  const res = await fetch(
    `${BASE_URL}/get_nkb_levels`,
    {
      headers: {
        Authorization: `Bearer ${loginData.token}`,
      },
    }
  );

  const data = await res.json();

  setRecords([
    {
      id: 1,
      symbol: "NSE:NIFTY",
      ...data.find(d => d.symbol === "NIFTY"),
    },
    {
      id: 2,
      symbol: "NSE:NIFTY_MID_SELECT",
      ...data.find(d => d.symbol === "MIDCPNIFTY"),
    },
  ]);
};


useEffect(() => {
  fetchLevels();
}, []);


  return (
    <>
      <Sidebar />

      <div className="add-user user-list">
        <Toolbar className="table-pre-head" center={centerToolbarTemplate} />

        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  {[
                    "S.No",
                    "Stock Symbol",
                    "Support",
                    "Resistence",
                    "Changed By",
                    "Changed At",
                    "Action",
                  ].map((head) => (
                    <TableCell
                      key={head}
                      align="center"
                      style={{
                        backgroundColor: "#23499E",
                        color: "#fff",
                        fontWeight: "bold",
                      }}
                    >
                      {head}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {records.map((row, index) => (
                  <TableRow key={row.id}>
                    <TableCell align="center">{index + 1}</TableCell>

                    <TableCell align="center">
                      {row.symbol}
                    </TableCell>

                    <TableCell align="center">
                      <input
                        className="table-input"
                        type="text"
                        inputMode="numeric"
                        value={row.support ?? ""}
                        onChange={(e) =>
                          handleChange(row.id, "support", e.target.value)
                        }
                      />
                    </TableCell>

                    <TableCell align="center">
                      <input
                        className="table-input"
                        type="text"
                        inputMode="numeric"
                        value={row.resistence ?? ""}
                        onChange={(e) =>
                          handleChange(row.id, "resistence", e.target.value)
                        }
                      />
                    </TableCell>

                    <TableCell align="center">
                      {row.changedBy || "-"}
                    </TableCell>

                    <TableCell align="center">
                      {row.changed_at ? (
                        <>
                          <div>
                            Date: {new Date(row.changed_at).toLocaleDateString("en-IN")}
                          </div>
                          <div>
                            Time: {new Date(row.changed_at).toLocaleTimeString("en-IN")}
                          </div>
                        </>
                      ) : (
                        "-"
                      )}
               </TableCell>


                    <TableCell align="center">
                    <Button
                      variant="contained"
                      style={{ backgroundColor: "#4CAF50", color: "#fff" }}
onClick={() => {
  setPendingRow(row);

  const hasValue = row.support !== "" || row.resistence !== "";
  setTelegramToggle(hasValue);

  setConfirmOpen(true);
}}

                    >                 
                      Update
                    </Button>                   
                      
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        <TelegramWidget />

  {/* success dialog */}
  <Dialog open={successOpen} onClose={() => setSuccessOpen(false)}>
<DialogTitle sx={{ color: "green", fontWeight: "bold" }}>
  Success
</DialogTitle>

  <DialogContent>
    <DialogContentText>
      Levels updated successfully
    </DialogContentText>
  </DialogContent>
</Dialog>

{/* error dialog */}
<Dialog open={errorOpen} onClose={() => setErrorOpen(false)}>
  <DialogTitle>
    <h4 style={{ color: "red" }}>Failure</h4>
  </DialogTitle>

  <DialogContent>
    <DialogContentText>
      {errorMessage}
    </DialogContentText>
  </DialogContent>
</Dialog>

{/* confirm dialog */}
<Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
  <DialogTitle style={{ color: "#2380DE" }}>
    Confirm Update
  </DialogTitle>

  <DialogContent>
  <DialogContentText sx={{ mb: 2 }}>
    Are you sure you want to update SR levels?
  </DialogContentText>

  {/* SUPPORT / RESISTANCE PREVIEW */}
  <Box
    display="flex"
    justifyContent="center"
    gap={3}
    mb={2}
    flexWrap="wrap"
  >
    {pendingRow?.support && (
      <Box sx={priceBoxStyle}>
        <div style={priceLabelStyle}>Support</div>
        <div style={{ ...priceValueStyle, color: "#c62828" }}>
          {pendingRow.support}
        </div>
      </Box>
    )}

    {pendingRow?.resistence && (
      <Box sx={priceBoxStyle}>
        <div style={priceLabelStyle}>Resistance</div>
        <div style={{ ...priceValueStyle, color: "#2e7d32" }}>
          {pendingRow.resistence}
        </div>
      </Box>
    )}
  </Box>

  {/* TELEGRAM TOGGLE */}
  
  {hasSRValue && (
  <Box display="flex" justifyContent="center">
    <FormControlLabel
      control={
        <Switch
          checked={telegramToggle}
          onChange={(e) => setTelegramToggle(e.target.checked)}
          color="primary"
        />
      }
      label="Send on Telegram"
    />
  </Box>
)}
</DialogContent>

<DialogActions sx={{ justifyContent: "center", gap: 2, pb: 2 }}>
  <Button
    variant="outlined"
    color="error"
    onClick={() => setConfirmOpen(false)}
    disabled={isSending}
  >
    Cancel
  </Button>

  <Button
    variant="outlined"
    color="success"
    onClick={confirmUpdate}
    disabled={isSending}
    autoFocus
  >
    {isSending
      ? "Updating..."
      : hasSRValue && telegramToggle
      ? "Send & Update"
      : "Update"}

  </Button>
</DialogActions>

</Dialog>

      </div>
    </>
  );
};

export default StockSRLevel;
 